export const DESCRIPTION_DISPLAY_LENGTH = 260;

export const isLongDescription = (description: string | undefined) =>
  Boolean(description && description.length > DESCRIPTION_DISPLAY_LENGTH);

export const getCutIndex = (text: string) => {
  const firstPart = text.slice(0, DESCRIPTION_DISPLAY_LENGTH);
  const secondPart = text.slice(DESCRIPTION_DISPLAY_LENGTH);
  const firstSpaceIndex = secondPart.indexOf(' ');

  if (~firstSpaceIndex) {
    return firstPart.length + firstSpaceIndex;
  }

  return text.length;
};

export const getDescriptionText = (description: string | undefined, isMinimized: boolean) => {
  if (!isMinimized || !description) {
    return description;
  }

  const cutIndex = getCutIndex(description);

  return `${description.slice(0, cutIndex)}${cutIndex < description.length ? '…' : ''}`;
};
